import { getBaseMetaTitle } from '@/environments'

const ArchiveWinner = () => import('./Main')

const route = {
  path: '/archive/winner',
  name: 'winnerArchive',
  meta: {
    title: `Archive - ${getBaseMetaTitle}`
  },
  component: ArchiveWinner
}

export default route
